<template>
  <v-dialog
      v-model="dialog"
      width="420"
      persistent
  >
    <v-btn
      flat
      route
      small
      slot="activator"
      @click="securityVerification = true"
    >
      <v-icon left>mdi-lock-reset</v-icon>
      Alterar senha
    </v-btn>
    <div v-if="securityVerification">
      <v-toolbar flat class="card-header">
        <v-icon>mdi-lock-reset</v-icon>
        <v-toolbar-title>Verificação de Segurança</v-toolbar-title>
      </v-toolbar>
      <stepper-security-verification
        @toggleDialog="toggleDialog"
        @displayNewPasswordModal="displayNewPasswordModal"
      />
    </div>
    <div v-if="cardUpdatePassword">
      <v-toolbar flat class="card-header">
        <v-icon left>mdi-lock-reset</v-icon>
        <v-toolbar-title>Alterar Senha</v-toolbar-title>
      </v-toolbar>
      <card-update-password
        @updatePassword="updatePassword"
        @toggleCardUpdatePassword="toggleCardUpdatePassword"
      />
    </div>
  </v-dialog>
</template>

<script>
import StepperSecurityVerification from '@/components/authentication/password/update/StepperSecurityVerification';
import CardUpdatePassword from '@/components/authentication/password/update/CardUpdatePassword';

export default {
  name: 'dialog-update-password',
  components: {
    StepperSecurityVerification,
    CardUpdatePassword,
  },
  data() {
    return {
      dialog: false,
      hidePassword: false,
      isOk: true,
      securityVerification: false,
      cardUpdatePassword: false,
    };
  },
  methods: {
    toggleDialog(bool) {
      this.dialog = bool;
    },
    displayNewPasswordModal() {
      this.securityVerification = false;
      this.cardUpdatePassword = true;
    },
    updatePassword() {
      this.dialog = false;
      this.cardUpdatePassword = false;
      if (this.isOk) {
        this.$store.dispatch('toggleSnackbar', {
          show: true,
          color: 'success',
          message: 'Sua senha foi atualizada.',
          button: { show: true, text: 'Fechar', message: '' },
          timeout: 6000,
        });
      } else {
        this.$store.dispatch('toggleSnackbar', {
          show: true,
          color: 'error',
          message: 'Não foi possível alterar sua senha. Tente novamente!',
          button: { show: true, text: 'Fechar', message: '' },
          timeout: 6000,
          messageIcon: 'mdi-alert-outline',
        });
      }
    },
    toggleCardUpdatePassword() {
      this.dialog = false;
      this.cardUpdatePassword = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/authentication/password/update/DialogUpdatePassword.vue